module.exports = __webpack_public_path__ + "static/media/tablet1.920fa5de.png";